/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ReportsIcon({ className, size = 'small' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M4 5.45L7.417 2h6.586c-.004 0-.005 4.666-.003 14H4.002L4 5.45zM15 2c0-.552-.453-1-.997-1H7L3 5.039V16c0 .552.456.999 1.002.999h9.996A.999.999 0 0015 16V2zm-3 8V9H6v1h6zm0 2v-1H6v1h6zm4-6v12H6v1h10.5a.5.5 0 00.5-.5V6h-1zM7 1.5V5H3.519v1H7.5a.5.5 0 00.5-.5v-4H7z"
      ></path>
    </svg>
  );
}
